import { endPoints, API_ROOT } from "../../../appSettings";
import { adalApiFetch } from "../../../authProvider";

export const getVoucher = (voucherCode) => {
  const url = `${API_ROOT}${endPoints.entitlement}/voucher-info/${voucherCode}`;
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  return (dispatch) => {
    return adalApiFetch(fetch, url, options, dispatch).then((response) =>
      response.json().then((json) => {
        if (!response.ok) {
          return Promise.reject(json);
        }

        return json;
      })
    );
  };
};

export const validateInvalidateVoucher = (id, isValid) => {
  const url = `${API_ROOT}${endPoints.entitlement}/${id}/${isValid}`;
  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
  };

  return (dispatch) => {
    return adalApiFetch(fetch, url, options, dispatch).then((response) => {
      return response.json().then((json) => {
        if (!response.ok) {
          return Promise.reject(json);
        }

        return json;
      });
    });
  };
};
